module.exports = __webpack_public_path__ + "static/media/shantanu.dbf0efe3.png";